'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { useRef, useState } from 'react';
import type { Swiper as SwiperType } from 'swiper';
import Tab from '@/app/cc/_component/ui/common/Tab/Tab';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/AnsimUsage/AnsimUsage.module.scss';
import AnsimUsageCards from '@/app/cc/_component/ui/section/AnsimUsage/AnsimUsageCards';
import { FirstUsageStepContent } from '@/app/cc/_component/ui/section/AnsimUsage/FirstUsageStepContent';
import { sendGA } from '@/app/cc/_util/sendGA';
export interface UsageStep {
  tabNumber: string;
  tabContent: ReactNode;
  description: ReactNode;
}
const commonUsageSteps: UsageStep[] = [{
  tabNumber: '02.',
  tabContent: <>
        중개사님을
        <br />
        통한 가입신청
      </>,
  description: <Text as="p" category="body" variant="r1" color="var(--color-gray-900)">
        가입은 계약하신 중개사님 통하여 진행돼요.
        <br />
        저희가 중개사님께 관련 안내드리며, 고객님께서는 별도로 챙기실 사항은 없어요.
      </Text>
}, {
  tabNumber: '03.',
  tabContent: <>
        가입 동의 및
        <br />
        이용료 결제
      </>,
  description: <Text as="p" category="body" variant="r1" color="var(--color-gray-900)">
        서비스 이용료 결제 링크가 고객님의 카카오톡 알림톡으로 전달돼요.
        <br />
        ​가입에 따른 관련 이용 동의도 함께 전달되니 읽어보시고 진행 부탁드려요.
      </Text>
}, {
  tabNumber: '04.',
  tabContent: <>가입 심사 대기</>,
  description: <Text as="p" category="body" variant="r1" color="var(--color-gray-900)">
        가입 가능 여부를 심사해요. (최대 2영업일 소요)
        <br />
        가입이 완료되는대로 고객님의 카카오톡 알림톡으로 안내드려요.
      </Text>
}, {
  tabNumber: '05.',
  tabContent: <>가입증명서 확인</>,
  description: <Text as="p" category="body" variant="r1" color="var(--color-gray-900)">
        잔금일 당일 계약하신 중개사님 통하여 가입증명서를 전달 받아주세요.​
        <br />
        해당 증명서를 바탕으로 안심케어 서비스를 제공하니 잘 보관해주세요.
      </Text>
}];
export default function AnsimUsage() {
  const $ = _c(35);
  const [selectedTab, setSelectedTab] = useState(0);
  const [isBeforeContract, setIsBeforeContract] = useState(false);
  const swiperRef = useRef(null);
  let t0;
  if ($[0] !== isBeforeContract) {
    t0 = isBeforeContract ? <>원하는 집 탐색<br />및 계약</> : "\uAC00\uC785\uBB38\uC758";
    $[0] = isBeforeContract;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <>{t0}</>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isBeforeContract) {
    t2 = <FirstUsageStepContent isBeforeContract={isBeforeContract} />;
    $[4] = isBeforeContract;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = [{
      tabNumber: "01.",
      tabContent: t1,
      description: t2
    }, ...commonUsageSteps];
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const usageSteps = t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = value => {
      setIsBeforeContract(value);
      sendGA(value ? "beforeUsageTab" : "afterUsageTab");
      setSelectedTab(0);
      swiperRef.current?.slideTo(0);
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleContractTab = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <br className="break" />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.titleContent}><Text as="h3" category="display" variant="eb2" color="var(--color-gray-900)">부동산 계약하며{t5} 한번에 가입하는<br /><Text as="span" category="display" variant="eb2" color="var(--color-primary-500)">안심케어 이용방법</Text></Text></div>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = !isBeforeContract;
  let t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => handleContractTab(false);
    t9 = <span>부동산 계약 후</span>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7) {
    t10 = <Tab size="lg" name="usageTab" color="gray" value={"\uBD80\uB3D9\uC0B0 \uACC4\uC57D \uD6C4"} active="fill_dark" id="afterContract" checked={t7} onChange={t8}>{t9}</Tab>;
    $[14] = t7;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => handleContractTab(true);
    t12 = <span>부동산 계약 전</span>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t11 = $[16];
    t12 = $[17];
  }
  let t13;
  if ($[18] !== isBeforeContract) {
    t13 = <Tab size="lg" name="usageTab" color="gray" value={"\uBD80\uB3D9\uC0B0 \uACC4\uC57D \uC804"} active="fill_dark" id="beforeContract" checked={isBeforeContract} onChange={t11}>{t12}</Tab>;
    $[18] = isBeforeContract;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t10 || $[21] !== t13) {
    t14 = <div className={styles.contractTabs}>{t10}{t13}</div>;
    $[20] = t10;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== isBeforeContract || $[24] !== selectedTab || $[25] !== usageSteps) {
    t15 = <AnsimUsageCards swiperRef={swiperRef} isBeforeContract={isBeforeContract} usageSteps={usageSteps} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />;
    $[23] = isBeforeContract;
    $[24] = selectedTab;
    $[25] = usageSteps;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const t16 = usageSteps[selectedTab];
  let t17;
  if ($[27] !== t16.description) {
    t17 = <div className={styles.usageDescription}>{t16.description}</div>;
    $[27] = t16.description;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t15 || $[30] !== t17) {
    t18 = <div className={styles.usageContent}>{t15}{t17}</div>;
    $[29] = t15;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t14 || $[33] !== t18) {
    t19 = <section className={styles.ansimUsage}><div className={styles.inner}>{t6}<div className={styles.container}>{t14}{t18}</div></div></section>;
    $[32] = t14;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  return t19;
}